import { IAssignedLinesTableData } from '.';
import { IAbstractRecord } from '@models';
import { IListingData } from '@models/listing';
import FormattingService from '@services/FormattingService';
import PrecisionService from '@services/PrecisionService';
import {
  trimTrailingZeros,
  valueCommaSeparated,
} from '@utils/formatting-utils';

export function mapToAssignedLinesListingData(
  data: IAbstractRecord
): IListingData {
  const list: IAbstractRecord = {};

  data.SalesforceManagement.queries.getBusinessPartnerLinesList.items.forEach(
    (obj: IAssignedLinesTableData) => {
      list[obj.salesforceManagement_BusinessPartnerLine_Id] = {
        salesforceManagement_BusinessPartnerLine_LineId:
          obj.salesforceManagement_BusinessPartnerLine_LineID?.id,
        salesforceManagement_BusinessPartnerLine_Id:
          obj.salesforceManagement_BusinessPartnerLine_Id,
        line_ExternalCode:
          obj.salesforceManagement_BusinessPartnerLine_LineID?.views
            ?.PlanConfigManagement_all.properties?.ExternalCode,
        line_Name:
          obj.salesforceManagement_BusinessPartnerLine_LineID?.views
            ?.PlanConfigManagement_all.properties?.Name,
        line_Status: FormattingService.formatEnumToDisplay(
          obj.salesforceManagement_BusinessPartnerLine_LineID?.views
            ?.PlanConfigManagement_all.properties?.Status
        ),
        salesforceManagement_BusinessPartnerLine_LineCommissionType:
          FormattingService.formatEnumToDisplay(
            obj.salesforceManagement_BusinessPartnerLine_LineCommissionType
          ),
        salesforceManagement_BusinessPartnerLine_ValueCurrency:
          obj.salesforceManagement_BusinessPartnerLine_LineCommissionType ===
          'VALUE'
            ? obj.salesforceManagement_BusinessPartnerLine_LineCommissionValue !==
              null
              ? `${
                  obj.salesforceManagement_BusinessPartnerLine_ValueCurrency
                    ?.Symbol
                } ${trimTrailingZeros(
                  valueCommaSeparated(
                    obj.salesforceManagement_BusinessPartnerLine_LineCommissionValue
                  ),
                  3,
                  true
                )}`
              : ''
            : obj.salesforceManagement_BusinessPartnerLine_LineCommissionRate !==
                null
              ? `${trimTrailingZeros(
                  PrecisionService.multiplyBy100(
                    Number(
                      obj.salesforceManagement_BusinessPartnerLine_LineCommissionRate
                    )
                  )
                )}%`
              : '',
        salesforceManagement_BusinessPartnerLine_ApplicableOn:
          obj.salesforceManagement_BusinessPartnerLine_ApplicableOn?.Title,
        salesforceManagement_BusinessPartnerLine_createdOn:
          obj.salesforceManagement_BusinessPartnerLine_createdOn,
        salesforceManagement_BusinessPartnerLine_modifiedOn:
          obj.salesforceManagement_BusinessPartnerLine_modifiedOn,
        salesforceManagement_BusinessPartnerLine_Status:
          FormattingService.formatEnumToDisplay(
            obj.salesforceManagement_BusinessPartnerLine_Status
          ),
        salesforceManagement_BusinessPartnerLine_CreditLimit:
          valueCommaSeparated(
            obj.salesforceManagement_BusinessPartnerLine_CreditLimit
          ),
        salesforceManagement_BusinessPartnerLine_CreditLimitCurrency:
          obj.salesforceManagement_BusinessPartnerLine_CreditLimitCurrency
            ?.Title,
        //     ?.Title,
        salesforceManagement_BusinessPartnerLine_GracePeriod:
          obj.salesforceManagement_BusinessPartnerLine_GracePeriod,

        AvailableActions:
          obj.salesforceManagement_BusinessPartnerLine_Status === 'ACTIVE'
            ? ['setDefaultCommission', 'updateCreditLimit', 'deactivate']
            : ['activate'],
      };
    }
  );

  return {
    pagedItems: list,
    pageSize:
      data?.SalesforceManagement?.queries?.getBusinessPartnerLinesList?.paging
        ?.pageSize,
    pageNumber:
      data?.SalesforceManagement?.queries?.getBusinessPartnerLinesList?.paging
        ?.pageNumber,
    totalCount:
      data?.SalesforceManagement?.queries?.getBusinessPartnerLinesList?.paging
        ?.totalCount,
  };
}
